import React, { useEffect, useState } from "react";
import isOutOfViewport from "utils/isOutOfViewport";
import useWindowSize from "hooks/windowSize";
import { Container, PopUp } from "./styles";
import { string } from "prop-types";
import { v4 as uuidv4 } from "uuid";

const Tooltip = ({ positionX, text, children }) => {
  const [state, setState] = useState({
    visible: false,
    positionX,
    id: uuidv4(),
  });
  const [width] = useWindowSize();

  useEffect(() => {
    const element = document.getElementById(state.id);
    element.style.top = getTopBottomPosition(element);

    const out = isOutOfViewport(element);
    if (out.left) {
      setState({ ...state, positionX: "left" });
    } else if (out.right) {
      setState({ ...state, positionX: "right" });
    }
    if (out.top) {
      element.style.bottom = getTopBottomPosition(element);
    } else if (out.bottom) {
      element.style.top = getTopBottomPosition(element);
    }
  }, [state, width]);

  function getTopBottomPosition(elem) {
    let topPosition = elem.offsetHeight + 17.5;
    return -topPosition + "px";
  }

  return (
    <Container
      onMouseOver={() => setState({ ...state, visible: true })}
      onMouseLeave={() => setState({ ...state, visible: false })}
      id="container"
    >
      {children}
      <PopUp positionX={state.positionX} visible={state.visible} id={state.id}>
        {text}
      </PopUp>
    </Container>
  );
};

export default Tooltip;

Tooltip.defaultProps = {
  positionX: "right",
  text: "",
};

Tooltip.propTypes = {
  positionX: string,
  text: string,
};
